export const Bio = {
    name : "Shikha Jain",
    roles : [
        "Full Stack Developer",
        ".Net Engineer",
        "Programmer"
    ],
    description: "",
    github: "https://github.com/shikha1720",
    //resume : "https://drive.google.com/file/d/12LAzWOlFI6Oyl4ZY9kHAX3OF7VpHFDSD/view?usp=drive_link",
    linkedin : "https://www.linkedin.com/in/shikha-jain-7aa912229",
    leetcode : "https://leetcode.com/jn_17/",
    twitter : "https://x.com/ShikhaJ1720?t=vuIaOHnUFL7Ezo57uadDyg&s=09",
    codepen : "https://codepen.io/sj_17",
};


export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name:"Angular",
          icon: "https://th.bing.com/th/id/OIP.gqVlHA9us8MsyCqfscbydgHaFj?rs=1&pid=ImgDetMain",
        },
        {
          name: "React",
          icon:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "JavaScript",
          icon:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Material UI",
          icon:
            "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg"
        },
        {
          name: "HTML",
          icon: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          icon:
            "https://cdn.worldvectorlogo.com/logos/css-3.svg",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: ".Net Core",
          icon: "https://wpguru.co.uk/wp-content/uploads/2020/04/dotnet-logo.png",
        },
        {
          name: "MVC",
          icon: "https://www.csharp411.com/wp-content/uploads/2023/05/MVC-Logo-1.jpg",
        },
        {
          name: "Node.js",
          icon: "https://imgs.search.brave.com/mt3_ltFUor3sJTiWHdmFbORv1QE3PUtM9gsygWvKgFQ/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9zZWVr/bG9nby5jb20vaW1h/Z2VzL04vbm9kZWpz/LWxvZ28tRkJFMTIy/RTM3Ny1zZWVrbG9n/by5jb20ucG5n",
        },
        {
          name: "Express.js",
          icon: "https://upload.vectorlogo.zone/logos/expressjs/images/a1b5cb1f-dae7-4971-ab5b-68efce751b0f.svg"
        },
      ],
    },
    {
      title: "Cloud",
      skills: [
          {
              name: "AWS",
              icon: "https://imgs.search.brave.com/7oeGsrL4dvFxaJETcut1tqHxgfsoiZvN7amgrq7hCUQ/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9sb2dv/cy13b3JsZC5uZXQv/d3AtY29udGVudC91/cGxvYWRzLzIwMjEv/MDgvQW1hem9uLVdl/Yi1TZXJ2aWNlcy1B/V1MtTG9nby03MDB4/Mzk0LnBuZw"
          },
          {
            name: "Microsoft Azure",
            icon: "https://seeklogo.com/images/M/microsoft-azure-logo-2575D39E82-seeklogo.com.png"
          },
          {
              name: "Docker",
              icon: "https://imgs.search.brave.com/09xRZm-6uXGnJxTbgcIpehTcFAS1wsE7aZANYHB_oYg/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9jZG40/Lmljb25maW5kZXIu/Y29tL2RhdGEvaWNv/bnMvbG9nb3MtYW5k/LWJyYW5kcy81MTIv/OTdfRG9ja2VyX2xv/Z29fbG9nb3MtMTI4/LnBuZw"
          },
      ]
  },
    {
      title: "Others",
      skills: [
        {
          name: "Postman",
          icon:
            "https://imgs.search.brave.com/50JDDd4L1QxFtnwMrj6rn158HP4VG0qHPxVKtKvCPn4/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9jZG4u/d29ybGR2ZWN0b3Js/b2dvLmNvbS9sb2dv/cy9wb3N0bWFuLnN2/Zw.svg",
        },
        {
          name: "Git",
          icon:
            "https://imgs.search.brave.com/lAxwlnkHcDxoP0r1gPCuufcYNwIjUEG9Inhli0EXaEQ/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9sb2dv/cy1kb3dubG9hZC5j/b20vd3AtY29udGVu/dC91cGxvYWRzLzIw/MjEvMDEvR2l0X0xv/Z28tNzAweDcwMC5w/bmc",
        },
        {
          name: "GitHub",
          icon:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "GitLab",
          icon:
            "https://cdn.worldvectorlogo.com/logos/gitlab-3.svg",
        },
        {
          name: "VS Code",
          icon:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Visual Studio",
          icon: "https://cswsolutions.com/media/1314/ms-visual-studio.jpg",
        },
        {
          name: "Microsoft SQL Server Management Studio",
          icon: "https://www.ubackup.com/screenshot/en/others/ssms/smss-logo.png",
        },
        {
          name: "RabbitMQ",
          icon: "https://download.logo.wine/logo/RabbitMQ/RabbitMQ-Logo.wine.png",
        },
        {
          name: "Eureka Server",
          icon: "https://4.bp.blogspot.com/-trV5mHmQdfE/XBZ8OmhhdwI/AAAAAAAAITA/jcJgWXbOy3AHO89lwV0SIrcepN-3d25BwCLcBGAs/s1600/GvuCOnQi_400x400.jpg",
        },
      ],
    },
];

export const experiences = [
  {
    id: 0,
    image: "https://imgs.search.brave.com/fyenv5op-68pvTW55lyt6QiNXeiJrngYKPtSqS3K37M/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9hc3Nl/dHMua3VudW51LmNv/bS9tZWRpYS9wcm9k/L3Byb2ZpbGVzL2xv/Z29zL2I5ODY0ZDdm/LWZiMTItNDU2NC1i/OTBlLTdkZDViNjQy/MTMwYl8xXzY0ZGM4/NWMwZTliNzMuZ2lm.gif",
    role: "Associate Software Engineer",
    company: "Nagarro",
    date: "Mar 2023 - Present",
    desc: "Actively engaged with .Net Core Working and its various tools, leverging my knowledge to optimize software development processes. Through hands-on knowlegde in .Net, Angular tools, I contribute to create effective workflow architecture, ensuring seamless integration between development and operations.",
    skills: [
      ".Net Core",
      "Angular",
      "Microservices",
      "AWS",
      "Microsoft Azure",
      "Docker",
      "React"
    ],
  },
]


export const projects = [
  {
    id: 0,
    title: "GroceryApp",
    date: "Dec 2023 - Jan 2024",
    description:
      "An Ecommerce Application with features including: Product Filtration, Sorting, Pagination, Seamless Cart & Order, and Admin Dashboard for Efficient Management.",
    image:
      "https://i.postimg.cc/Qx31g8tV/Grocery-App.png",
    tags: [
      ".Net Core",
      "Angular",
      "Miscrosoft SQL Server",
      "JWT",
    ],
    category: "web app",
    github: "https://github.com/shikha1720/VegApp",
    webapp: "",
  },
  {
    id: 1,
    title: "BlogHouse",
    date: "Aug 2023 - Aug 2023",
    description:
      "A Blog Post Application using React, Redux and ContextApi. Application displays the list of blog post. Users can add new post, view the details of the blog post, edit the blog post and can delete the blog post as well as Users can like the blog post.",
    image:
      "https://i.postimg.cc/tTGZDHWR/HomePage.png",
    tags: [
      "React",
      "JavaScript",
      "HTML",
      "css",
      "Redux",
      "Context Api"
    ],
    category: "web app",
    github: "https://github.com/shikha1720/BlogHouse_React",
    webapp: "https://blog-house-app-sj.surge.sh/",
  },
  
  
  {
    id: 2,
    title: "CarRental",
    date: "Sep 2023 - Sep 2023",
    description:
      "A car rent platform with car agreemenet and admin as the rights to update delete and accept your agreement, with the intractive UI, filters and pagination.",
    image:
      "https://i.postimg.cc/Y910mHBY/Car-Rental.png",
    tags: [
      ".Net Core",
      "Angular",
      "Miscrosoft SQL Server",
      "JWT",
    ],
    category: "web app",
    github: "https://github.com/shikha1720/CarRent",
    webapp: "",
  },
  {
    id: 3,
    title: "BookBoorow",
    date: "Nov 2023 - Nov 2023",
    description:
      "A web app that has the functionality to Login users with JWT for authentication. Allows user to borrow and lent books an the basis of the token they have, if they not have any token they can not borrow books. The app features a responsive UI for a seamless user experience across all devices.",
    image:
      "https://i.postimg.cc/G2n27YgD/Book-Boorrow.png",
    tags: [
      ".Net Core",
      "Angular",
      "Miscrosoft SQL Server",
      "JWT",
      "Material UI",
      "Three-Tier architecture"
    ],
    category: "web app",
    github: "https://github.com/shikha1720/BorrowBookApp",
    webapp: "",
  },
  {
    id: 4,
    title: "BookReadingEvent",
    date: "Jul 2023 - Jul 2023",
    description:
      "A web application that showcases all the book reading event created by the user as well as admin and also can invite other user through there mail, made responsive user interface for seamless experience across all devices.",
    image:
      "https://i.postimg.cc/tgVVJ9VX/Book-Reading-Event.png",
    tags: [
      "MVC",
      "HTML",
      "css",
      "Design Pattern",
      "Three-Tier architecture",
      "Microsoft SQL Server"
    ],
    category: "web app",
    github: "https://github.com/shikha1720/MVC_BookReadingEvent",
    webapp: "",
  },
  {
    id: 5,
    title: "ResultManagement",
    date: "Aug 2023 - Sep 2023",
    description:
      "A web application in which students result is added, updated and deleted by the teacher and result is seen by the student, made responsive user interface for seamless experience across all devices.",
    image:
      "https://i.postimg.cc/yx1XnLNk/Teacher-Login.png",
    tags: [
      "Node JS",
      "Express",
      "Sequelize",
      "My SQL",
      "Nodemon"
    ],
    category: "web app",
    github: "https://github.com/shikha1720/ResultManagement_NodeJs",
    webapp: "",
  },
]


export const education = [
  {
    id: 0,
    image: "https://images.collegedunia.com/public/college_data/images/logos/16303981071519887772398.png?h=80&w=80&mode=stretch",
    school: "Pranveer Singh Institute of Technology, Kanpur, Uttar Pradesh",
    date: "Nov 2021 - June 2023",
    grade: "8.87 CGPA",
    desc: "I completed my Master's degree from PSIT Kanpur. In span of 2 years I worked on my problem solving skills with languages like C, C++, Python and got to work on multiple technologies like JavaScript, HTML, CSS. My course work included Data Structures & Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    degree: "Master of Computer Applications",
  },
  {
    id: 1,
    image: "https://illuminateminds.com/wp-content/uploads/Dr-Virendra-Swarup-Institute-of-Computer-Studies-VSICS-Kanpur-1080x675.png",
    school: "Dr Virendra Swarup Institute of Computer Studies, Kanpur",
    date: "Jul 2017 - Sep 2020",
    grade: "75.14%",
    desc: "I completed my Bachelor's degree in Computer Application from Dr Virendra Swarup Institute of Computer Studies Kanpur. Where I was engaged with coursework and multiple extra curriculum activities",
    degree: "Bachelor of Computer Applications",
  },
];




  